import { useQuery } from 'react-query'

import useApis from '@/common/hooks/useApis'
import { PrefetchRequest } from '@/common/types'

const QUERY_KEY = 'places'

interface Props {
  keyword?: string
}

const usePlaces = (props: Props = {}) => {
  const { apis } = useApis()

  const { data = [], ...query } = useQuery([QUERY_KEY, props], () =>
    apis.search.searchByName(props)
  )

  return { data, ...query }
}

export const prefetchPlaces = async (
  { apis, queryClient }: PrefetchRequest,
  props: Props
) => {
  return queryClient.fetchQuery([QUERY_KEY, props], () =>
    apis.search.searchByName(props)
  )
}

export default usePlaces
